import { Button, message, Modal, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  getNachAuditLog,
  MandateApproveUpdateFailedToCompleteStatus,
  NachAuditLogType,
} from 'api/nach';
import { LoadingScreen } from 'common/components';
//import xlsx from 'json-as-xlsx';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { memo, useCallback, useState } from 'react';

const MandateActionColumn = (record: any) => {
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [auditLog, setAuditLog] = useState<NachAuditLogType[]>([]);

  // console.log('Audit logs ', auditLog);

  function getFullDate(date: string, format = 'DD/MM/YYYY HH:mm:ss') {
    if (date != null) {
      const dateMoment = moment(new Date(date)).format(format);
      return dateMoment;
    }
  }

  // const downloadAudit = (record: any) => {
  //   getNachAuditLog({ mandateId: record.record.mandateId }).then((_x) => {
  //     let settings = {
  //       fileName: record.record.mandateId + ' Mandate Log', // Name of the resulting spreadsheet
  //       extraLength: 3, // A bigger number means that columns will be wider
  //       writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
  //       writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
  //       RTL: false, // Display the columns from right-to-left (the default value is false)
  //     };
  //     const content = _x.data || [];
  //     const updatedData = content.map((item, index) => ({
  //       ...item,
  //       ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
  //     }));

  //     let data = [
  //       {
  //         sheet: 'Sheet',
  //         columns: [
  //           { label: 'ROWNUM', value: 'ROWNUM' },
  //           { label: 'Mandate Request ID', value: 'mandateId' },
  //           { label: 'Mandate Request Json', value: 'mandateRequestJson' },
  //           { label: 'Mandate Response Json', value: 'mandateResponseJson' },
  //           { label: 'Type', value: 'type' },
  //         ],
  //         content: updatedData,
  //       },
  //     ];
  //     xlsx(data, settings);
  //   });
  // };

  const downloadAudit = (record: any) => {
    getNachAuditLog({ mandateId: record.record.mandateId }).then((_x) => {
      const content = _x.data || [];
      const worksheetData: any[][] = [];

      // Add header
      worksheetData.push([
        'ROWNUM',
        'Mandate Request ID',
        'Mandate Request Json',
        'Mandate Response Json',
        'Type',
      ]);

      // Constants
      const maxLength = 32767;

      // Build row data
      content.forEach((item, index) => {
        const rownum = index + 1;
        const requestJsonChunks = chunkString(item.mandateRequestJson || '', maxLength);
        const responseJsonChunks = chunkString(item.mandateResponseJson || '', maxLength);
        const maxChunks = Math.max(requestJsonChunks.length, responseJsonChunks.length);

        for (let i = 0; i < maxChunks; i++) {
          worksheetData.push([
            i === 0 ? rownum : '', // only show ROWNUM in the first chunk row
            i === 0 ? item.mandateId : '',
            requestJsonChunks[i] || '',
            responseJsonChunks[i] || '',
            i === 0 ? item.type : '',
          ]);
        }
      });

      // Convert to worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet');

      // Save file
      XLSX.writeFile(workbook, `${record.record.mandateId} Mandate Log.xlsx`);
    });

    // Helper to split long strings into chunks
    const chunkString = (str: string, size: number) => {
      const re = new RegExp(`.{1,${size}}`, 'g');
      return str.match(re) || [];
    };
  };


  const showModal = useCallback(
    (record: any) => {
      setIsModalLoading(true);
      getNachAuditLog({ mandateId: record.record.mandateId })
        .then((res) => {
          if (res.status == 'SUCCESS' && res.data) {
            setAuditLog(res.data);
          }
        })
        .finally(() => {
          setIsModalLoading(false);
        });

      setIsModalOpen(true);
    },
    [record]
  );

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const auditCols: ColumnsType<NachAuditLogType> = [
    {
      key: 'mandateId',
      title: 'Mandate Request ID',
      dataIndex: 'mandateId',
      width: 20,
      align: 'center',
    },
    {
      key: 'mandateRequestJson',
      title: 'Mandate Request Json',
      dataIndex: 'mandateRequestJson',
      width: 30,
      ellipsis: true,
      render: (record) => <Tooltip>{record}</Tooltip>,

      // align: 'center mandateResponseJson',
    },
    {
      key: 'mandateResponseJson',
      title: 'Mandate Response Json',
      dataIndex: 'mandateResponseJson',
      width: 30,
      ellipsis: true,
      render: (record) => <Tooltip>{record}</Tooltip>,
    },
    {
      key: 'requestDate',
      title: 'Request Date',
      dataIndex: 'requestDate',
      width: 20,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'type',
      title: 'Type',
      dataIndex: 'type',
      width: 20,
      ellipsis: true,
      // render: (date: string) => getFullDate(date),
    },
  ];

  const handleApproveMandateRetry = (mandateId: number) => {
    console.log('Mandate Id', mandateId);

    // MandateApproveUpdateFailedToCompleteStatus(mandateId)
    // .then((res) => {
    //   setRetryRes(res);

    //   if (res.responseCode == '200') {
    //     message.success('Done Successfully!');
    //     setIsLoading(false);
    //     handleReset();
    //   } else {
    //     message.error(res.message);
    //   }
    // })
    // .finally(() => {
    //   setRetry(!_isRetry);
    // });

    MandateApproveUpdateFailedToCompleteStatus({ mandateId }).then((res) => {
      if (res.status == 'SUCCESS') {
        message.success('Successfully retry');
      }
    });
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModal(record);
        }}
        style={{ flex: '1' }}
      >
        Audit
      </Button>
      <Button
        type="primary"
        onClick={() => {
          downloadAudit(record);
        }}
        style={{ flex: '1' }}
      >
        Download
      </Button>
      {record.record.mandateStatus == 'MANDATE_CREATION_FAILED' ? (
        <Button
          type="primary"
          onClick={() => {
            handleApproveMandateRetry(record.record.mandateId);
          }}
        >
          Retry
        </Button>
      ) : null}

      <Modal
        okButtonProps={{
          style: { marginBottom: '10px', marginRight: '10px', marginTop: '20px', padding: '30px' },
        }}
        title="Mandate Log Details"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="70%"
        footer={[<div></div>]}
      >
        <div className="">
          {isModalLoading ? (
            <LoadingScreen />
          ) : (
            <Table<NachAuditLogType>
              dataSource={auditLog}
              columns={auditCols}
              scroll={{ x: 2000, y: 500 }}
              pagination={false}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default memo(MandateActionColumn);
